import { InspectorControls, useBlockProps } from "@wordpress/block-editor";
import {
	PanelBody,
	RangeControl,
	ToggleControl,
	Button,
	ButtonGroup,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { Fragment } from "react";
import { TaxonomyTermsSelect } from "../../components/taxonomy-terms-select/taxonomy-terms-select";
import ServerSideRender from "@wordpress/server-side-render";
import { withSelect } from "@wordpress/data";
import { compose } from "@wordpress/compose";

import './posts-carousel.scss';

export function Edit(props) {
	const { attributes, setAttributes, categories } = props;
	const blockProps = useBlockProps();

	let slider, swiperTest;

	if (!slider) {
		slider = document.querySelector(".a3wbks-posts-carousel");
	}

	if (slider) {
		swiperTest = new Swiper(slider, {
			slidesPerView: attributes.slides_lg,
			enabled: false,
			loop: attributes.isLoop,
			autoplay: {
				delay: attributes.autoplaySpeed,
			},
			spaceBetween: attributes.margin,
			pagination: attributes.hasNavigationDots
				? { type: "bullets", el: ".swiper-pagination", clickable: true }
				: false,
		});

		swiperTest.pagination.update();
	}

	return (
		<Fragment>
			<InspectorControls>
				<PanelBody
					title={__("Query settings", "a3web-blocks")}
					initialOpen={true}
				>
					<RangeControl
						label={__("Nombre de posts dans le slider", "a3web-blocks")}
						value={attributes.perPage}
						onChange={(perPage) => setAttributes({ perPage })}
						min={1}
						max={10}
					/>

					<TaxonomyTermsSelect
						terms={categories}
						selectedTerm={attributes.terms}
						selectTerm={(categoryId) => setAttributes({ terms: categoryId })}
						label="Catégorie"
					/>
				</PanelBody>

				<PanelBody
					title={__("Slider settings", "a3web-blocks")}
					initialOpen={false}
				>
					<p>Nombre de slides :</p>
					<ButtonGroup>
						<Button
							isPrimary={attributes.currentButton == "sm"}
							onClick={() => setAttributes({ currentButton: "sm" })}
						>
							SM
						</Button>
						<Button
							isPrimary={attributes.currentButton == "md"}
							onClick={() => setAttributes({ currentButton: "md" })}
						>
							MD
						</Button>
						<Button
							isPrimary={attributes.currentButton == "lg"}
							onClick={() => setAttributes({ currentButton: "lg" })}
						>
							LG
						</Button>
						<Button
							isPrimary={attributes.currentButton == "xl"}
							onClick={() => setAttributes({ currentButton: "xl" })}
						>
							XL
						</Button>
					</ButtonGroup>

					{attributes.currentButton == "xl" ? (
						<RangeControl
							value={attributes.slides_xl}
							onChange={(slides_xl) => setAttributes({ slides_xl })}
							min={1}
							max={6}
						/>
					) : (
						""
					)}
					{attributes.currentButton == "lg" ? (
						<RangeControl
							value={attributes.slides_lg}
							onChange={(slides_lg) => setAttributes({ slides_lg })}
							min={1}
							max={6}
						/>
					) : (
						""
					)}
					{attributes.currentButton == "md" ? (
						<RangeControl
							value={attributes.slides_md}
							onChange={(slides_md) => setAttributes({ slides_md })}
							min={1}
							max={6}
						/>
					) : (
						""
					)}

					{attributes.currentButton == "sm" ? (
						<RangeControl
							value={attributes.slides_sm}
							onChange={(slides_sm) => setAttributes({ slides_sm })}
							min={1}
							max={6}
						/>
					) : (
						""
					)}

					<ToggleControl
						label="Afficher les points de navigation"
						help={
							attributes.hasNavigationDots
								? "Points affichés ✔"
								: "Points cachés ❌"
						}
						checked={attributes.hasNavigationDots}
						onChange={() => {
							setAttributes({
								hasNavigationDots: !attributes.hasNavigationDots,
							});
						}}
					/>

					<ToggleControl
						label="Afficher les flèches de navigation"
						help={
							attributes.hasNavigationArrows
								? "Flèches affichées. ✔"
								: "Flèches cachées ❌"
						}
						checked={attributes.hasNavigationArrows}
						onChange={() => {
							setAttributes({
								hasNavigationArrows: !attributes.hasNavigationArrows,
							});
						}}
					/>

					<ToggleControl
						label="Le carousel tourne en boucle ?"
						help={
							attributes.isLoop ? "Boucle activée ✔" : "Boucle désactivée ❌"
						}
						checked={attributes.isLoop}
						onChange={() => {
							setAttributes({
								isLoop: !attributes.isLoop,
							});
						}}
					/>

					<ToggleControl
						label="Le carousel défile automatiquement ?"
						help={
							attributes.isAutoplay
								? "Défilement automatique ✔"
								: "Défilement manuel 👆"
						}
						checked={attributes.isAutoplay}
						onChange={() => {
							setAttributes({
								isAutoplay: !attributes.isAutoplay,
							});
						}}
					/>

					{attributes.isAutoplay ? (
						<RangeControl
							label={__("Vitesse de défilement automatique", "a3web-blocks")}
							value={attributes.autoplaySpeed}
							onChange={(autoplaySpeed) => setAttributes({ autoplaySpeed })}
							min={1000}
							max={6000}
							step={100}
						/>
					) : (
						""
					)}

					<RangeControl
						label={__("Temps de changement de slides", "a3web-blocks")}
						value={attributes.swipeSpeed}
						onChange={(swipeSpeed) => setAttributes({ swipeSpeed })}
						min={50}
						max={3000}
						step={50}
					/>

					<RangeControl
						label={__("Espace entre les slides", "a3web-blocks")}
						value={attributes.margin}
						onChange={(margin) => setAttributes({ margin })}
						min={0}
						max={26}
						step={1}
					/>
				</PanelBody>
			</InspectorControls>

			<Fragment>
				<div {...blockProps}>
					<ServerSideRender
						block="a3web-blocks/posts-carousel"
						attributes={{
							hasNavigationArrows: attributes.hasNavigationArrows,
							hasNavigationDots: attributes.hasNavigationDots,
							terms: attributes.terms,
						}}
					/>
				</div>
			</Fragment>
		</Fragment>
	);
}

const applyWithSelect = withSelect((select) => {
	return {
		categories: select("core").getEntityRecords("taxonomy", "category", {
			per_page: -1,
		}),
	};
});

export default compose(applyWithSelect)(Edit);
